import dayjs from "dayjs";

export const dateFormat = (value) => {
  if (value) {
    let objectDate = new Date(value);
    let day = ("0" + objectDate.getDate()).slice(-2);
    let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
    let year = objectDate.getFullYear();

    return day + "-" + month + "-" + year;
  } else {
    return "--";
  }
};


export const isPastDate = (date) => {
  return dayjs(date).isBefore(dayjs(), "day");
};
